import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarDataPasien from "../../components/TopBarDataPasien";
import SemuaDataPasienTK from "../../components/SemuaDataPasienTK";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanDataPasien() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarDataPasien />

        {/* Konten utama */}
        <div className="detailpasien-page">
          <SemuaDataPasienTK/>
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPasien;
